import React, { useEffect, useRef } from 'react';

const Animation = () => {
  const animationContainer = useRef(null);
  const animationPath = '/animations/animation.json';

  useEffect(() => {
    let animationInstance;

    // Only run in the browser
    if (typeof window !== 'undefined') {
      import('lottie-web').then(lottie => {
        animationInstance = lottie.loadAnimation({
          container: animationContainer.current,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          path: animationPath,
          rendererSettings: {
            progressiveLoad: true,
          },
        });
      });
    }

    // Cleanup on unmount
    return () => {
      animationInstance?.destroy();
    };
  }, [animationPath]);

  return (
    <div className="animation">
      <div ref={animationContainer} />
    </div>
  );
};

export default Animation;
